// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/client/modules/reporting/modules/reporting-list/components/report-container/accounts-receivable-aging-report/components/accounts-receivable-aging-header/accounts-receivable-aging-header.less
// module id = 3867
// module chunks = 0